import api from "~/services/api";

const buildServiceTree = (businessServices) => {
	let tree = [];
	const services = businessServices.filter(service => !!service.serviceName);
	for (let i = 0; i < services?.length; i++) {
		let levels = services[i]?.featureItems;
		const nameService = services[i].serviceName;

		let levelsName = String(nameService).split(" - ");
		let branch = tree;
		for (let j = 0; j < levels?.length; j++) {
			let levelIndex = -1;
			for (let k = 0; k < branch.length; k++) {
				if (branch[k].id === levels[j]) {
					levelIndex = k;
					break;
				}
			}
			if (levelIndex === -1) {
				if(levelsName[j] !== '*'){
					branch.push({
						name: levelsName[j],
						branchs: [],
						service: j === levels.length - 1 ? services[i] : null,
						id: services[i].featureItems[j],
					});
					branch = branch[branch.length - 1].branchs;
				}
			} else {
				branch = branch[levelIndex].branchs;
			}
		}
	}
	return tree;
};

const petPreselection = (tree, pet) => {
	let level = tree;
	for (let i = 0; i < pet.featureItems.length; i++) {
		for (let j = 0; j < level.length; j++) {
			if (pet.featureItems[i] === level[j].id) {
				level = level[j].branchs;
			}
		}
	}
	return level;
};

const servicePreselection = (tree, service) => {
	let level = tree;
	for (let i = 0; i < service.featureItems.length-1; i++) {
		for (let j = 0; j < level.length; j++) {
			if (service.featureItems[i] === level[j].id) {
				level = level[j].branchs;
			}
		}
	}
	return level;
};

const getVisibleBranchs = (level) =>
	(level ?? []).filter((branch) => !!branch?.name && branch.name !== "null");

// Nível "passa-através": exibe apenas um grupo (ex.: raiz = [Cílios]).
const isSingleGroupLevel = (level) => {
	const visibleBranchs = getVisibleBranchs(level);
	return visibleBranchs.length === 1 && visibleBranchs[0]?.branchs?.length > 0;
};

// Desce automaticamente pelos níveis que só contêm um grupo.
const expandSingleGroupLevels = (level) => {
	let path = [];
	let currentLevel = level ?? [];
	while (isSingleGroupLevel(currentLevel)) {
		const group = getVisibleBranchs(currentLevel)[0];
		path.push(group);
		currentLevel = group.branchs;
	}
	return { path, level: currentLevel };
};

// Nível anterior ao voltar, pulando níveis passa-através.
// Retorna null quando não há nível anterior útil (equivale a fechar a seleção).
const getPreviousLevel = (tree, levelPath) => {
	const levelOf = (path) => (path.length > 0 ? path[path.length - 1].branchs : tree);
	let path = (levelPath ?? []).slice(0, -1);
	while (path.length > 0 && isSingleGroupLevel(levelOf(path))) {
		path = path.slice(0, -1);
	}
	if (path.length === 0 && isSingleGroupLevel(tree)) {
		return null;
	}
	return { path, level: levelOf(path) };
};

export default {
	buildServiceTree,
	petPreselection,
	servicePreselection,
	isSingleGroupLevel,
	expandSingleGroupLevels,
	getPreviousLevel,
};
